// extracted by mini-css-extract-plugin
export default {"button":"hl-z","reviewSort":"il-z"};